import styled from 'styled-components';

import { dangerColor } from '../../../lib/theme';

export const RowGrid = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;

  .context-row-type {
    width: 132px;
    flex-shrink: 0;
  }

  /* Bounded so the row actions hug the picker instead of floating to the far
     right edge of the panel. */
  .context-row-instance {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 380px;
  }

  /* Locked chips size to their content so edit / remove sit right beside them. */
  .context-row-chips {
    min-width: 0;
  }

  /* A selected player a later-added higher context no longer covers. */
  .context-chip-misfit {
    background: transparent;
    border: 1px solid ${dangerColor};
    color: ${dangerColor};
  }
  .context-chip-misfit .MuiChip-deleteIcon {
    color: ${dangerColor};
  }
`;

export const MisfitHelper = styled.span`
  color: ${dangerColor};
`;
